
<app-modal-notification #confirmation></app-modal-notification>

<div style="margin-top: 30px; margin-bottom: 30px; padding-bottom: 50px;" class="container">
  <div style="margin-bottom: 30px;" class="modal-title text-center" i18n="label|Application form for practitioner.@@labelPractitionerApplication">Application for Healthcare Providers</div>
  <div class="d-flex flex-fill justify-content-center mb-4 zaya-form-help-text text-center" i18n="label|Help text for submitting the practitioner application.@@labelApplicationHelpText">
    Welcome! We’re so excited that you are interested in being a part of our community! Please keep in mind that all the information entered in your application will be automatically
    uploaded into your zaya profile page — if your application has been approved. You will have the ability to make changes to your profile once your profile has been created. Once
    you have submitted your application, we will review it and get back to you as soon as possible.
  </div>

  <form [formGroup]="practitionerForm" (ngSubmit)="onSubmit()">

    <!-------------------------------- Your information block -------------------------------->
    <hr>
    <div class="zaya-form-header" i18n="label|Indicates where practitioners enter their information.@@labelYourInformation">Your information</div>

    <div formGroupName="userData">
      <span
        class="help-block"
        *ngIf="practitionerForm.get('userData.profileImage').invalid && practitionerForm.get('userData.profileImage').touched"
        i18n="error message|The message shown when an image has not been uploaded.@@errorImage">
          Please upload a valid image.
      </span>

      <div class="form-group d-flex" style="position: relative;" *ngIf="isMobileScreen">
        <img class="profile-image" alt="" height="152" width="152" [src]="profileImageUrl">
        <div class="upload-button" (click)="uploadButton.click()" i18n="button|Button for practitioner to upload an image.@@buttonUploadImage">Upload image</div>
      </div>
      <div class="form-group d-flex" style="position: relative;">
        <input #uploadButton type="file" id="profileImage" class="form-control" (change)="getImage($event)" accept=".png,.jpg" formControlName="profileImage" hidden />
        <img class="profile-image" alt="" height="200" width="200" [src]="profileImageUrl" *ngIf="!isMobileScreen">
        <div class="upload-button" (click)="uploadButton.click()" i18n="button|Button for practitioner to upload an image.@@buttonUploadImage" *ngIf="!isMobileScreen">Upload image</div>
        <div class="flex-fill">
          <div class="row">
            <div class="col-xs-12 col-md-7 form-group">
              <label for="title" class="zaya-form-sub-header" i18n="label|Professional title of practitioner.@@labelProfessionalTitle">What is your profession?</label>
              <div class="d-flex flex-fill mb-4 zaya-form-help-text" i18n="label|Help text for the practitioner professional title.@@labelApplicationProfessionalTitleHelpText">
                eg. Acupuncturist, Psychotherapist, Physiotherapist, etc.
              </div>
              <input type="text" id="title" class="form-control" formControlName="title">
              <span
                class="help-block"
                *ngIf="practitionerForm.get('userData.title').invalid && practitionerForm.get('userData.title').touched"
                i18n="error message|The message shown when a title has not been entered.@@errorProfessionalTitle">
                  Please enter a valid professional title.
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-2 col-md-2 form-group">
              <label for="salutation" class="zaya-form-sub-header" i18n="label|Salutation of practitioner.@@labelSalutation">Salutation</label>
              <input type="text" id="salutation" class="form-control" formControlName="salutation">
            </div>
            <div class="col-xs-12 col-md-5 form-group">
              <label for="firstName" class="zaya-form-sub-header" i18n="label|First name of practitioner.@@labelFirstName">First name</label>
              <input type="text" id="firstName" class="form-control" formControlName="firstName">
              <span
                class="help-block"
                *ngIf="practitionerForm.get('userData.firstName').invalid && practitionerForm.get('userData.firstName').touched"
                i18n="error message|The message shown when a first name has not been entered.@@errorFirstName">
                  Please enter a valid first name.
              </span>
            </div>
            <div class="col-xs-12 col-md-5 form-group">
              <label for="lastName" class="zaya-form-sub-header" i18n="label|Last name of practitioner.@@labelLastName">Last name</label>
              <input type="text" id="lastName" class="form-control" formControlName="lastName">
              <span
                class="help-block"
                *ngIf="practitionerForm.get('userData.lastName').invalid && practitionerForm.get('userData.lastName').touched"
                i18n="error message|The message shown when a last name has not been entered.@@errorLastName">
                  Please enter a valid last name.
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="form-group d-flex">
        <img class="profile-image" alt="" height="152" width="152" [src]="profileImageUrl">
        <div>
          <label for="profileImage" class="zaya-form-sub-header">Upload image</label>
          <input type="file" id="profileImage" class="form-control" (change)="getImage($event)" accept=".png,.jpg" formControlName="profileImage" />
          <span
            class="help-block"
            *ngIf="practitionerForm.get('userData.profileImage').invalid && practitionerForm.get('userData.profileImage').touched">
              Please upload a valid image.
          </span>
        </div>
      </div> -->

      <div class="row">
        <div class="col-xs-12 col-md-6 form-group">
          <label for="email" class="zaya-form-sub-header" i18n="label|The email of a user.@@labelWorkEmail">Work email</label>
          <div class="d-flex flex-fill mb-4 zaya-form-help-text" i18n="label|Help text for the work email of a practitioner.@@labelApplicationWorkEmailHelpText">
            This information will not be listed on your profile.
          </div>
          <input type="email" id="email" class="form-control" formControlName="email">
          <span
            class="help-block"
            *ngIf="practitionerForm.get('userData.email').invalid && practitionerForm.get('userData.email').touched"
            i18n="error message|The message shown when an email has not been entered.@@errorEmail">
              Please enter a valid email.
          </span>
        </div>
        <div class="col-xs-12 col-md-6 form-group">
          <label for="phoneNumber" class="zaya-form-sub-header" i18n="label|The phone number of a user.@@labelPhoneNumber">Phone number</label>
          <div class="d-flex flex-fill mb-4 zaya-form-help-text" i18n="label|Help text for phone number of a practitioner.@@labelApplicationPhoneNumberHelpText">
            This information will not be listed on your profile.
          </div>
          <input type="tel" id="phoneNumber" class="form-control" formControlName="phoneNumber">
          <span
            class="help-block"
            *ngIf="practitionerForm.get('userData.phoneNumber').invalid && practitionerForm.get('userData.phoneNumber').touched"
            i18n="error message|The message shown when a phone number has not been entered.@@errorPhoneNumber">
              Please enter a valid phone number.
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-6 form-group">
          <label for="gender" class="zaya-form-sub-header" i18n="label|The gender of a user.@@labelGender">Gender</label>
          <select id="gender" class="form-control" formControlName="gender">
            <option *ngFor="let gender of genders" [value]="gender" i18n="label|Options used for selecting gender.@@labelGenderOptions">
              { gender, select, Male {Male} Female {Female} Non-binary {Non-binary}}
            </option>
          </select>
          <span
            class="help-block"
            *ngIf="practitionerForm.get('userData.gender').invalid && practitionerForm.get('userData.gender').touched"
            i18n="error message|The message shown when a gender has not been selected.@@errorGender">
              Please select a gender.
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-12 form-group">
          <label for="bio" class="zaya-form-sub-header" i18n="label|the bio of a practitioner.@@labelTellUs">Tell us about yourself</label>
          <div class="d-flex flex-fill mb-4 zaya-form-help-text" i18n="label|Help text for the bio of a practitioner.@@labelApplicationTellUsHelpText">
            This is a great opportunity to tell us about your practice, your background, and why your work is important to you.
          </div>
          <textarea name="bio" id="bio" cols="30" rows="4" class="form-control" formControlName="bio" maxlength="700"></textarea>
          <div class="zaya-form-help-text text-right">{{ practitionerForm.value.userData.bio ? practitionerForm.value.userData.bio.length : 0 }} / 700</div>
          <span
            class="help-block"
            *ngIf="practitionerForm.get('userData.bio').invalid && practitionerForm.get('userData.bio').touched"
            i18n="error message|The message shown when a bio is not valid.@@errorBio">
              Please enter a valid bio.
          </span>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-12 form-group">
          <label for="approach" class="zaya-form-sub-header" i18n="label|the approach of a practitioner.@@labelPractitionerApproach">What can clients expect in your sessions?</label>
          <div class="d-flex flex-fill mb-4 zaya-form-help-text" i18n="label|Help text for the approach of a practitioner.@@labelApplicationApproachHelpText">
            Please describe your approach and what clients can expect during and after a session with you.
          </div>
          <textarea name="approach" id="approach" cols="30" rows="4" class="form-control" formControlName="approach" maxlength="700"></textarea>
          <div class="zaya-form-help-text text-right">{{ practitionerForm.value.userData.approach ? practitionerForm.value.userData.approach.length : 0 }} / 700</div>
          <span
            class="help-block"
            *ngIf="practitionerForm.get('userData.approach').invalid && practitionerForm.get('userData.approach').touched"
            i18n="error message|The message shown when a practitioner approach is not valid.@@errorApproach">
              Please enter a valid approach.
          </span>
        </div>
      </div>
    </div>
    <!-------------------------------- End of your information block -------------------------------->

    <!-------------------------------- Your experience block -------------------------------->
    <hr>
    <div class="zaya-form-header" i18n="label|Indicates where a practitioner enters their experience.@@labelYourExperience">Your experience</div>

    <div formGroupName="experienceData">
      <div class="row" *ngFor="let educationControl of getControls('experienceData.education'); let i = index;">
        <div class="col-xs-12 col-md-6 form-group">
          <div formArrayName="education">
            <label for="education{{i}}" class="zaya-form-sub-header" i18n="label|Practitioner education experience.@@labelEducation">University/Institute/School</label>
            <div class="input-group">
              <input id="education{{i}}" type="text" class="form-control" [formControlName]="i">
            </div>
            <span
              class="help-block"
              *ngIf="i == 0 && practitionerForm.get('experienceData.education.0').invalid && practitionerForm.get('experienceData.education.0').touched"
              i18n="error message|The message shown when education has not been entered.@@errorEducation">
                Please enter at least 1 university/institute/school.
            </span>
          </div>
        </div>
        <div class="col-xs-12 col-md-6 form-group">
          <div formArrayName="degree">
            <label for="degree{{i}}" class="zaya-form-sub-header" i18n="label|Practitioner educational degree.@@labelDegree">Degree</label>
            <div class="input-group">
              <input id="degree{{i}}" type="text" class="form-control" [formControlName]="i">
            </div>
            <span
              class="help-block"
              *ngIf="i == 0 && practitionerForm.get('experienceData.degree.' + i).invalid && practitionerForm.get('experienceData.degree.' + i).touched"
              i18n="error message|The message shown when degree has not been entered.@@errorDegree">
                Please enter a valid degree.
            </span>
            <div class="text-right" *ngIf="i > 0">
              <span
                class="zaya-form-link"
                (click)="onRemoveControl('experienceData.education', i);
                onRemoveControl('experienceData.degree', i);">
                x <ng-container i18n="button|Used to remove an education a user has entered.@@buttonRemoveEducation">Remove this university/institute/school</ng-container>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center" style="margin-bottom: 10px;">
        <span
          class="zaya-form-link"
          (click)="onAddControl('experienceData.education');
          onAddControl('experienceData.degree')">
          + <ng-container i18n="button|Used to add an education.@@buttonAddEducation">Add another university/institute/school</ng-container>
        </span>
      </div>

      <div class="row" *ngFor="let licenseControl of getControls('experienceData.licenses'); let i = index;">
        <div class="col-xs-12 col-md-6 form-group">
          <div formArrayName="licenses">
            <label for="license{{i}}" class="zaya-form-sub-header" i18n="label|Practitioner training.@@labelTraining">Training/Experience</label>
            <div class="input-group">
              <input id="license{{i}}" type="text" class="form-control" [formControlName]="i">
            </div>
            <span
              class="help-block"
              *ngIf="i == 0 && practitionerForm.get('experienceData.licenses.0').invalid && practitionerForm.get('experienceData.licenses.0').touched"
              i18n="error message|The message shown when training has not been entered.@@errorTraining">
                Please enter at least 1 training/experience.
            </span>
            <div class="text-right" *ngIf="i > 0">
              <span class="zaya-form-link" (click)="onRemoveControl('experienceData.licenses', i);">
                x <ng-container i18n="button|Used to remove a license a user has entered.@@buttonRemoveTraining">Remove this training/experience</ng-container>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center" style="margin-bottom: 10px;">
        <span class="zaya-form-link" (click)="onAddControl('experienceData.licenses');">
          + <ng-container i18n="button|Used to add a license.@@buttonAddTraining">Add another training/experience</ng-container>
        </span>
      </div>

      <div class="row" *ngFor="let languageControl of getControls('experienceData.languages'); let i = index;">
        <div class="col-xs-12 col-md-6 form-group">
          <div formArrayName="languages">
            <label for="language{{i}}" class="zaya-form-sub-header" i18n="label|The language a practitioner speaks.@@labelLanguage">Language</label>
            <select id="language{{i}}" class="form-control" [formControlName]="i">
              <option *ngFor="let language of _filterLanguages(i)" [value]="language" i18n="label|Options used for selecting a language.@@labelLanguageOptions">
                {language, select, Select... {Select...} English {English} German {German} Arabic {Arabic} Spanish {Spanish} French {French} Chinese {Chinese} Portuguese {Portuguese} Russian {Russian} Turkish {Turkish} Hindi {Hindi} Vietnamese {Vietnamese}}
              </option>
            </select>
            <span
              class="help-block"
              *ngIf="i == 0 && practitionerForm.get('experienceData.languages.0').invalid && practitionerForm.get('experienceData.languages.0').touched"
              i18n="error message|The message shown when language has not been entered.@@errorLanguage">
                Please enter at least 1 language.
            </span>
            <div class="text-right" *ngIf="i > 0">
              <span class="zaya-form-link" (click)="onRemoveControl('experienceData.languages', i);">
                x <ng-container i18n="button|Used to remove a language a user has entered.@@buttonRemoveLanguage">Remove this language</ng-container>
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center" style="margin-bottom: 30px;">
        <span class="zaya-form-link" (click)="onAddControl('experienceData.languages');">
          + <ng-container i18n="button|Used to add a language.@@buttonAddLanguage">Add another language</ng-container>
        </span>
      </div>

      <div formArrayName="professionalBodies">
        <div class="row" *ngFor="let _ of getControls('experienceData.professionalBodies'); let i = index;">
          <div class="col-xs-12 col-md-6 form-group">
            <label for="professionalBody{{i}}" class="zaya-form-sub-header" i18n="label|The professional body a practitioner practices.@@labelProfessionalBody" *ngIf="i === 0">Professional body you belong to</label>
            <select class="form-control" (change)="updateProfessionalBody(i, $event.target.value)">
              <option *ngFor="let professionalBody of professionalBodies" [value]="professionalBody">
                {{professionalBody}}
              </option>
            </select>
            <div class="text-right" *ngIf="i > 0">
              <span class="zaya-form-link" (click)="onRemoveControl('experienceData.professionalBodies', i);">
                x <ng-container i18n="button|Used to remove a professional body a user has entered.@@buttonRemoveProfessionalBody">Remove this professional body</ng-container>
              </span>
            </div>
            <input id="professionalBody{{i}}" type="text" class="form-control col-xs-12 col-md-6 mt-3" [formControlName]="i" hidden>
          </div>
        </div>
      </div>

      <div class="text-center" style="margin-bottom: 30px;">
        <span class="zaya-form-link" (click)="onAddControl('experienceData.professionalBodies');">
          + <ng-container i18n="button|Used to add a professional body.@@buttonAddProfessionalBody">Add another professional body</ng-container>
        </span>
      </div>

      <div formArrayName="accreditedRegisters">
        <div class="row" *ngFor="let _ of getControls('experienceData.accreditedRegisters'); let i = index;">
          <div class="col-xs-12 col-md-6 form-group">
            <label for="accreditedRegister{{i}}" class="zaya-form-sub-header" i18n="label|The accredited register a practitioner practices.@@labelAccreditedRegister" *ngIf="i === 0">Accredited register membership</label>
            <select class="form-control" (change)="updateAccreditedRegister(i, $event.target.value)">
              <option *ngFor="let accreditedRegister of accreditedRegisters" [value]="accreditedRegister">
                {{accreditedRegister}}
              </option>
            </select>
            <div class="text-right" *ngIf="i > 0">
              <span class="zaya-form-link" (click)="onRemoveControl('experienceData.accreditedRegisters', i);">
                x <ng-container i18n="button|Used to remove an accredited register a user has entered.@@buttonRemoveAccreditedRegister">Remove this accredited register membership</ng-container>
              </span>
            </div>
            <input id="accreditedRegister{{i}}" type="text" class="form-control col-xs-12 col-md-6 mt-3" [formControlName]="i" hidden>
          </div>
        </div>
      </div>

      <div class="text-center" style="margin-bottom: 30px;">
        <span class="zaya-form-link" (click)="onAddControl('experienceData.accreditedRegisters');">
          + <ng-container i18n="button|Used to add an accredited register.@@buttonAddProfessionalBody">Add another accredited register membership</ng-container>
        </span>
      </div>
    </div>
    <!-------------------------------- End of your experience block -------------------------------->

    <!-------------------------------- Your services block -------------------------------->
    <hr>
    <div class="zaya-form-header" i18n="label|Indicates where practitioner will enter their services.@@labelYourServices">Your therapies & services</div>
    <div class="d-flex flex-fill justify-content-center mb-4 zaya-form-help-text text-center" i18n="label|Help text for the services a practitioner offers.@@labelApplicationServicesHelpText">
      Please enter the name of the therapy you offer along with the services you offer under that therapy. If you offer more than one service under that therapy, click the + Add another service button
      along with the corresponding costs and length of each session. Once you have finished entering one service, click the "+add another service" button to add the next service. If you offer more than
      one therapy, e.g. you offer massage and acupuncture, make sure to add another therapy. Make sure to double check your spelling and grammar. For example: instead of typing "massage therapy", type
      "Massage Therapy".
    </div>

    <div formGroupName="serviceData">
      <div class="form-group">
        <div class="card" *ngFor="let specialtyControl of getControls('serviceData.specialties'); let i = index;" [class.mt-3]="i > 0">
          <div class="card-body">
            <div>
              <div class="d-flex flex-fill mb-4 zaya-form-help-text" i18n="label|Help text for the therapy type of a practitioner.@@labelApplicationTherapyTypeHelpText">
                Please choose the category that your therapy belongs to. "Mind" refers to practitioners that specialize in mental health for ex. Psychotherapy.
                "Body" refers to practitioners that specialize in physical health for ex. Acupuncture.
              </div>
              <div class="row">
                <div class="col-xs-12 col-md-3">
                  <div formArrayName="categories">
                    <label for="category{{i}}" class="zaya-form-sub-header" i18n="label|The category of the specialty a practitioner practices.@@labelSpecialtyCategory">Therapy Category</label>
                    <select name="category{i}}" id="category{{i}}" class="form-control" (change)="updateSpecialtyCategory(i, $event.target.value)">
                      <option value="body">Body</option>
                      <option value="mind">Mind</option>
                    </select>
                    <input id="category{{i}}" type="text" class="form-control col-xs-12 col-md-6 mt-3" [formControlName]="i" hidden>
                    <span
                      class="help-block"
                      *ngIf="i == 0 && practitionerForm.get('serviceData.categories.0').invalid && practitionerForm.get('serviceData.categories.0').touched"
                      i18n="error message|The message shown when a therapy category has not been entered.@@errorTherapyCategory">
                        Please enter at least 1 therapy category.
                    </span>
                  </div>
                </div>
                <div class="col-xs-12 col-md-9 form-group">
                  <div formArrayName="specialties">
                    <label for="specialty{{i}}" class="zaya-form-sub-header" i18n="label|The specialty a practitioner practices.@@labelSpecialty">Therapy you offer e.g. Massage</label>
                    <select class="form-control" (change)="updateSpecialty(i, $event.target.value)">
                      <option *ngFor="let specialty of practitionerForm.get('serviceData.categories.' + i).value === 'mind' ? mindSpecialties : bodySpecialties" [value]="specialty">
                        {{specialty}}
                      </option>
                    </select>
                    <input id="specialty{{i}}" type="text" class="form-control col-xs-12 col-md-6 mt-3" [formControlName]="i" hidden>
                    <div class="text-right" *ngIf="i > 0">
                      <span class="zaya-form-link" (click)="onRemoveControl('serviceData.specialties', i); onRemoveControl('serviceData.specialtyData', i); onRemoveControl('serviceData.categories', i);">
                        x <ng-container i18n="button|Used to remove a specialty.@@buttonRemoveSpecialty"></ng-container>Remove this therapy
                      </span>
                    </div>
                    <span
                      class="help-block"
                      *ngIf="i == 0 && practitionerForm.get('serviceData.specialties.0').invalid && practitionerForm.get('serviceData.specialties.0').touched"
                      i18n="error message|The message shown when a specialty has not been entered.@@errorSpecialty">
                        Please enter at least 1 therapy.
                    </span>
                  </div>
                </div>
              </div>
              <div formArrayName="specialtyData">
                <div formGroupName="{{i}}" *ngFor="let therapyControl of getControls('serviceData.specialtyData.' + i + '.therapies'); let j = index;">
                  <hr *ngIf="j > 0">
                  <div class="row">
                    <div class="col-xs-12 col-md-6 form-group">
                      <div formArrayName="therapies">
                        <label for="therapy{{j}}" class="zaya-form-sub-header" i18n="label|The therapy corresponding to a practitioner specialty.@@labelTherapy">
                          Service(s) you offer under this therapy e.g. Deep Tissue
                        </label>
                        <input id="therapy{{j}}" type="text" class="form-control" [formControlName]="j">
                        <span
                          class="help-block"
                          *ngIf="j == 0 && practitionerForm.get('serviceData.specialtyData.' + i + '.therapies.' + j).invalid && practitionerForm.get('serviceData.specialtyData.' + i + '.therapies.' + j).touched"
                          i18n="error message|The message shown when a therapy has not been entered.@@errorTherapy">
                            Please enter a valid service.
                        </span>
                        <div class="text-right" *ngIf="j > 0">
                          <span class="zaya-form-link" (click)="onRemoveControl('serviceData.specialtyData.' + i + '.therapies', j); onRemoveControl('serviceData.specialtyData.' + i + '.costs', j); onRemoveControl('serviceData.specialtyData.' + i + '.descriptions', j); onRemoveControl('serviceData.specialtyData.' + i + '.durations', j);">
                            x <ng-container i18n="button|Used to remove a therapy the user has entered.@@buttonRemoveTherapy">Remove this service</ng-container>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-md-12 form-group">
                      <div formArrayName="descriptions">
                        <label for="description{{j}}" class="zaya-form-sub-header" i18n="label|The description of a practitioner service.@@labelTherapyDescription">Brief description of this service</label>
                        <textarea id="description{{j}}" cols="30" rows="4" class="form-control" [formControlName]="j" maxlength="300"></textarea>
                        <div class="zaya-form-help-text text-right">
                          {{ practitionerForm.value.serviceData.specialtyData[i].descriptions[j] ? practitionerForm.value.serviceData.specialtyData[i].descriptions[j].length : 0 }} / 300
                        </div>
                        <span
                          class="help-block"
                          *ngIf="j == 0 && practitionerForm.get('serviceData.specialtyData.' + i + '.descriptions.' + j).invalid && practitionerForm.get('serviceData.specialtyData.' + i + '.descriptions.' + j).touched"
                          i18n="error message|The message shown when a therapy description has not been entered.@@errorTherapyDescription">
                            Please enter a valid description.
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-xs-12 col-md-6 form-group">
                      <div formArrayName="costs">
                        <label for="cost{{j}}" class="zaya-form-sub-header" i18n="label|The price of a practitioner service.@@labelCost">Cost of service</label>
                        <div class="input-group">
                          <input id="cost{{j}}" type="number" class="form-control" [formControlName]="j">
                        </div>
                        <span
                          class="help-block"
                          *ngIf="j == 0 && practitionerForm.get('serviceData.specialtyData.' + i + '.costs.' + j).invalid && practitionerForm.get('serviceData.specialtyData.' + i + '.costs.' + j).touched"
                          i18n="error message|The message shown when a cost has not been entered.@@errorCost">
                            Please enter a valid cost.
                        </span>
                      </div>
                    </div>
                    <div class="col-xs-12 col-md-6 form-group">
                      <div formArrayName="durations">
                        <label for="duration{{j}}" class="zaya-form-sub-header" i18n="label|The duration of a practitioner service.@@labelDuration">Duration of service in minutes</label>
                        <div class="input-group">
                          <input id="duration{{j}}" type="number" class="form-control" [formControlName]="j">
                        </div>
                        <span
                          class="help-block"
                          *ngIf="j == 0 && practitionerForm.get('serviceData.specialtyData.' + i + '.durations.' + j).invalid && practitionerForm.get('serviceData.specialtyData.' + i + '.durations.' + j).touched"
                          i18n="error message|The message shown when a duration has not been entered.@@errorDuration">
                            Please enter a valid duration.
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="text-center" style="margin-bottom: 10px;">
                  <span
                    class="zaya-form-link"
                    (click)="onAddControl('serviceData.specialtyData.' + i + '.therapies'); onAddControl('serviceData.specialtyData.' + i + '.costs'); onAddControl('serviceData.specialtyData.' + i + '.descriptions'); onAddControl('serviceData.specialtyData.' + i + '.durations');">
                    + <ng-container i18n="button|Used to add a therapy.@@buttonAddTherapy">Add another service for this therapy</ng-container>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="text-center" style="margin-bottom: 10px;">
        <span
          class="zaya-form-link"
          (click)="onAddControl('serviceData.categories'); onAddControl('serviceData.specialties'); onAddSpecialtyDataControl();">
          + <ng-container i18n="button|Used to add a specialty.@@buttonAddSpecialty">Add another therapy you offer</ng-container>
        </span>
      </div>

      <div class="d-flex flex-fill my-4 zaya-form-help-text" i18n="label|Help text for the issues a practitioner specializes in.@@labelApplicationIssuesHelpText">
        Use the dropdown list below, please include any conditions you specialize in treating within your practice. If you do not see your symptom or condition listed, please make
        sure to choose "Other" in order to type in the name of the condition. Please make sure to double check your spelling and grammar.
      </div>
      <div class="row" *ngFor="let conditionControl of getControls('serviceData.conditions'); let i = index;">
        <div class="col-xs-12 col-md-3">
          <div formArrayName="conditionCategories">
            <label for="category{{i}}" class="zaya-form-sub-header" i18n="label|The category of the condition a practitioner practices.@@labelConditionCategory" *ngIf="i === 0">Condition Category</label>
            <select name="category{i}}" id="category{{i}}" class="form-control" (change)="updateConditionCategory(i, $event.target.value)">
              <option value="body">Body</option>
              <option value="mind">Mind</option>
            </select>
            <span
              class="help-block"
              *ngIf="i == 0 && practitionerForm.get('serviceData.conditionCategories.0').invalid && practitionerForm.get('serviceData.conditionCategories.0').touched"
              i18n="error message|The message shown when a condition category has not been entered.@@errorConditionCategory">
                Please enter at least 1 condition category.
            </span>
          </div>
        </div>
        <div class="col-xs-12 col-md-9 form-group">
          <div formArrayName="conditions">
            <label for="condition{{i}}" class="zaya-form-sub-header" i18n="label|The condition a practitioner specializes in.@@labelCondition" *ngIf="i === 0">Conditions you specialize in</label>
            <select class="form-control" (change)="updateCondition(i, $event.target.value)">
              <option *ngFor="let condition of practitionerForm.get('serviceData.conditionCategories.' + i).value === 'mind' ? mindConditions : bodyConditions" [value]="condition">
                {{condition}}
              </option>
            </select>
            <input id="condition{{i}}" type="text" class="form-control col-xs-12 mt-3" [formControlName]="i" hidden>
            <span
              class="help-block"
              *ngIf="i == 0 && practitionerForm.get('serviceData.conditions.0').invalid && practitionerForm.get('serviceData.conditions.0').touched"
              i18n="error message|The message shown when a condition has not been entered.@@errorCondition">
                Please enter at least 1 condition.
            </span>
            <div class="text-right" *ngIf="i > 0">
              <span class="zaya-form-link" (click)="onRemoveControl('serviceData.conditionCategories', i); onRemoveControl('serviceData.conditions', i)">
                x <ng-container i18n="button|Used to remove a condition the practitioner has entered.@@buttonRemoveCondition">Remove this condition</ng-container>
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center" style="margin-bottom: 30px;">
        <span
          class="zaya-form-link"
          (click)="onAddControl('serviceData.conditionCategories'); onAddControl('serviceData.conditions')">
          + <ng-container i18n="button|Used to add a condition.@@buttonAddCondition">Add another condition</ng-container>
        </span>
      </div>
    </div>
    <!-------------------------------- End of your services block -------------------------------->

    <!-------------------------------- Business information block -------------------------------->
    <hr>
    <div class="zaya-form-header" i18n="label|Indicates where the practitioner will enter their business information.@@labelYourBusiness">Your business</div>

    <div formGroupName="businessData">
      <div class="row">
        <div class="col-xs-12 col-md-6 form-group">
          <label for="organization" class="zaya-form-sub-header" i18n="label|The name of the practitioner organization.@@lableOrganizationName">Organization Name (Optional)</label>
          <input type="text" id="organization" class="form-control" formControlName="organization">
        </div>
        <div class="col-xs-12 col-md-6">
          <div class="form-group">
            <label for="offersVirtual" class="zaya-form-sub-header" i18n="label|Does the practitioner offer virtual services.@@labelOffersOnlineServices">Do you offer online services?</label>
            <select id="offersVirtual" class="form-control" formControlName="offersVirtual">
              <option [value]="true" i18n="label|Agree.@@labelYes">Yes</option>
              <option [value]="false" i18n="label|Disagree.@@labelNo">No</option>
            </select>
            <span
              class="help-block"
              *ngIf="practitionerForm.get('businessData.offersVirtual').invalid && practitionerForm.get('businessData.offersVirtual').touched"
              i18n="error message|The message shown when an option has not been selected.@@errorOption">
                Please select a valid option.
            </span>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="location" class="zaya-form-sub-header" i18n="label|The location of a practitioner.@@labelBusinessAddress">Business Address</label>
        <app-google-places (setAddress)="getAddress($event)" addressType="geocode" id="location" controlName="location"></app-google-places>
        <span
          class="help-block"
          *ngIf="practitionerForm.get('location').invalid && practitionerForm.get('location').touched"
          i18n="error message|The message shown when an location has not been entered.@@errorAddress">
            Please select a valid location.
        </span>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-12">
          <div class="form-group">
            <label for="healthCategory" class="zaya-form-sub-header" i18n="label|The practitioner health category.@@labelHealthCategory">Category of practice</label>
            <div class="mb-4 zaya-form-help-text" i18n="label|Help text for the practitioner health category.@@labelApplicationHealthCategoryHelpText">
              Mental well-being includes: psychologists, psychotherapists and other practitioners that address the psychological well-being of an individual.
              Physical well-being includes: physicians, osteopaths, acupuncturists and other practitioners that address the lifestyle behavior choices of
              an individual to ensure health and avoid preventable diseases and conditions.
            </div>
            <select id="healthCategory" class="form-control" formControlName="healthCategory">
              <option *ngFor="let category of healthCategories" [value]="category" i18n="label|Options used for selecting health category.@@labelHealthCategoryOptions">
                { category, select, Mental well-being {Mental well-being} Physical well-being {Physical well-being} Both {Both}}
              </option>
            </select>
            <span
              class="help-block"
              *ngIf="practitionerForm.get('businessData.healthCategory').invalid && practitionerForm.get('businessData.healthCategory').touched"
              i18n="error message|The message shown when an option has not been selected.@@errorOption">
                Please select a valid option.
            </span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-12 col-md-6 form-group">
          <div formArrayName="testimonials">
            <div class="zaya-form-sub-header" i18n="label|The previous reviews of a practitioner.@@labelPreviousTestimonials">Previous Testimonials</div>
            <span class="form-text" style="margin-bottom: 15px;" i18n="label|Description of previous testimonials.@@labelPreviousTestimonialsDescription">
              (Optional): If you'd like to speed up your application process, please enter up to 3 email addresses of previous patients or clients that have
              worked with you within the last 2 years. Once you have submitted your application, we will send an email asking for them to provide their overall
              experience with you using our testimonial review system. Learn more about our testimonial review system <a href="https://www.zayamed.com/ourreviewsystem" target="_blank">here</a>.
            </span>
            <div class="mb-4 zaya-form-help-text" i18n="label|Help text for the emails collected for testimonials.@@labelApplicationTestimonialsEmailHelpText">
              The email addresses you provide us will not be stored or processed. You can learn more by reading our privacy policy <a href="https://www.zayamed.com/privacypolicy" target="_blank">here</a>.
            </div>
            <div *ngFor="let testimonialControls of getControls('businessData.testimonials'); let i = index;">
              <label for="testimonial{{i}}" class="zaya-form-sub-header" i18n="label|Email.@@labelEmail">Email</label>
              <input id="testimonial{{i}}" type="email" class="form-control" [formControlName]="i">
              <span
                class="help-block"
                *ngIf="practitionerForm.get('businessData.testimonials.' + i).invalid && practitionerForm.get('businessData.testimonials.' + i).touched"
                i18n="error message|The message shown when an email has not been entered.@@errorEmail">
                  Please enter a valid email.
              </span>
              <div class="text-right" *ngIf="i > 2">
                <span class="zaya-form-link" (click)="onRemoveControl('businessData.testimonials', i)">
                  x <ng-container i18n="button|Used to remove an email the practitioner has entered.@@buttonRemoveEmail">Remove this email</ng-container>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-6 form-group">
          <label class="zaya-form-sub-header" i18n="label|Shows the preview of an email.@@labelEmailPreview">Email Preview</label>
          <div class="card">
            <div class="card-body">
              <h5 class="card-title" *ngIf="!practitionerForm.get('userData.firstName').value" i18n="label|The name of a practitioner.@@labelYourName">Your Name</h5>
              <h5 class="card-title" *ngIf="practitionerForm.get('userData.firstName').value">{{practitionerForm.get('userData.firstName').value + ' ' + practitionerForm.get('userData.lastName').value}}</h5>
              <fa-icon [icon]="starIcon" [styles]="{'color': 'gold'}"></fa-icon>
              <fa-icon [icon]="starIcon" [styles]="{'color': 'gold'}"></fa-icon>
              <fa-icon [icon]="starIcon" [styles]="{'color': 'gold'}"></fa-icon>
              <fa-icon [icon]="starIcon" [styles]="{'color': 'gold'}"></fa-icon>
              <fa-icon [icon]="starIcon" [styles]="{'color': 'gold'}"></fa-icon>
              <p class="card-text" style="margin-top: 10px;" i18n="label|Sample email sent for testimonials.@@labelEmailPreviewDescription">
                Thanks for being a valued client. I just applied on Zaya to find more excellent clients like you, and reviews are a big part of my profile. Can you take a moment to provide feedback
                about your experience while working with me? I'd love if my future clients could hear about your experience firsthand.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center" style="margin-bottom: 30px;">
        <span
          class="zaya-form-link"
          (click)="onAddControl('businessData.testimonials')">
          + <ng-container i18n="button|Used to add an email.@@buttonAddEmail">Add another email</ng-container>
        </span>
      </div>
    </div>
    <!-------------------------------- End of business information block -------------------------------->

    <div *ngIf="error">
      <hr>
      <div class="alert alert-danger">
        <p>Whoops there was a problem with your submission.</p>
        <div [innerHtml]="error"></div>
        <p>Please resolve the above issues and re-submit the form when you are done.</p>
      </div>
    </div>
    <hr>
    <div class="d-flex flex-fill justify-content-center">
      <button type="submit" class="btn btn-primary submit-btn" [disabled]="disableSubmit" i18n="button|Submits the practitioner application.@@buttonSubmitApplication">Submit Application</button>
      <app-loader *ngIf="isLoading"></app-loader>
    </div>
  </form>
</div>
